import { useState } from 'react';

import { DatePicker, Input, Modal } from '@components';
import { getTermStartDateLimit } from '@features/group-management/helpers/customTerm';
import { formatISODate } from '@utils/date';

interface TermStartDateProps {
  startDate: string;
  onStartDateChange: (date: string) => void;
}

const TermDueDateSelection = ({
  startDate,
  onStartDateChange
}: TermStartDateProps) => {
  const [isStartDateModalOpen, setIsStartDateModalOpen] =
    useState<boolean>(false);

  const minDate = new Date(getTermStartDateLimit());

  return (
    <>
      <Input
        leftIconName="calendar"
        value={startDate ? formatISODate({ date: startDate }) : ''}
        onClick={() => {
          setIsStartDateModalOpen(true);
        }}
        placeholder="dd/mm/yyy"
      />
      {isStartDateModalOpen && (
        <Modal
          isOpen={isStartDateModalOpen}
          onCancel={() => setIsStartDateModalOpen(false)}
        >
          <DatePicker
            confirmButtonLabel="Apply"
            confirmButtonStyle="text-primary"
            handleConfirm={(date) => {
              onStartDateChange(date);
              setIsStartDateModalOpen(false);
            }}
            cancelButtonLabel="Cancel"
            handleCancel={() => {
              setIsStartDateModalOpen(false);
            }}
            minDate={minDate}
            selectedDate={(startDate && new Date(startDate)) || minDate}
            calendarStyle="!bg-bgBase"
            title="Select Term Start Date"
          />
        </Modal>
      )}
    </>
  );
};

export default TermDueDateSelection;
